<template>
  <div>
    <div class="row beast-member-add" v-if="canEdit">
      <div class="alert col-12" :class="`alert-${alertStatus}`" v-if="alertMessage" v-text="alertMessage"></div>
      <div class="col-10">
        <div class="form-group">
          <label>Team Name</label>
          <input type="text" class="form-control" v-model="teamInfo.name"/>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group text-center">
          <label>&nbsp;</label>
          <div class="btn-group btn-block">
            <button class="btn btn-success" @click="storeData">
              <font-awesome-icon :icon="faPlus"/>
            </button>
            <button class="btn btn-danger" @click="clearData">
              <font-awesome-icon :icon="faTimes"/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-striped table-borderless beast-table">
      <thead>
      <tr>
        <th class="beast-table-name">Name</th>
        <th class="beast-table-edit" v-if="isMember">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-bind:key="team.name"
          v-for="team in teams.data">
        <td class="beast-table-name">
          {{team.name}}
        </td>
        <td class="beast-table-edit" v-if="isMember">
          <router-link :to="`/organization/${org.slug}/teams/${team.id}/packages`" class="btn btn-secondary">
            Packages
          </router-link>
          <router-link :to="`/organization/${org.slug}/teams/${team.id}/members`" class="btn btn-secondary">
            Members
          </router-link>
          <button class="btn btn-danger" v-if="canEdit" @click="remove(team.id)">
            <font-awesome-icon :icon="faTimes"/>
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <pagination :current="teams.page"
                :pages="teams.pages"
                @pageChange="readData"/>
  </div>
</template>


<style scoped lang="scss">
  .beast-table {
    .beast-table-name {
      width: 55%;
      vertical-align: middle;
      a {
        color: $beast-dark-gray;

        &:hover {
          color: $beast-green
        }
      }
    }
    .beast-table-edit {
      width: 45%;
      vertical-align: middle;
      text-align: center;

      .btn {
        margin-right: 5px;
      }
    }
  }

  .beast-member-add {
    label {
      font-weight: bold;
    }
  }
</style>

<script>
import { faTimes, faPlus } from "@fortawesome/free-solid-svg-icons";

import Pagination from "../../components/utils/Pagination.vue";

export default {
  components: { Pagination },
  props: {
    org: Object
  },
  watch: {
    async org() {
      await this.readData();
    }
  },
  computed: {
    apiURL() {
      return `/organizations/${this.org.slug}/teams`;
    },
    canEdit() {
      return this.isMember && this.org.allowedToEdit;
    },
    isMember() {
      return this.$auth.check() && this.org && this.org.isMember;
    },
    faTimes() {
      return faTimes;
    },
    faPlus() {
      return faPlus;
    }
  },
  data() {
    return {
      alertStatus: "success",
      alertMessage: "",
      teams: {
        data: [],
        count: 0,
        page: 0,
        pages: 0,
        size: 0
      },
      teamInfo: {
        name: ""
      }
    };
  },
  methods: {
    async storeData() {
      try {
        await this.axios.post(this.apiURL, this.teamInfo);
        this.clearData();
        await this.readData();
      } catch (e) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(e);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 2500);
      }
    },
    clearData() {
      this.teamInfo = {
        name: "",
      };
    },
    async readData(page = 1) {
      const queryParams = {
        params: {
          size: 10,
          page
        }
      };

      const response = await this.axios.get(this.apiURL, queryParams);
      this.teams = response.data;
    },
    async remove(teamId) {
      try {
        await this.$dialog.confirm("Are you sure you want to delete the team?", {
          okText: "Yes",
          cancelText: "Cancel"
        });
        await this.axios.delete(`${this.apiURL}/${teamId}`);
        this.alertStatus = "success";
        this.alertMessage = "Operation was successfully executed.";
        await this.readData();
      } catch (err) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(err);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    _extractErrors(err) {
      if (!err.response || !err.response.data) {
        return err.message;
      }

      return err.response.data.message;
    }
  },
  async beforeMount() {
    if (this.org.slug !== "") {
      await this.readData();
    }
  }
};
</script>
